/*
 *  CNNIX - Site Navigation
 *  @description:   Site navigation with custom page nav built in.
 *  @language:      React + JSX
 *  @author:        Kenneth Uzquiano (kenneth.uzquiano@turner.com)
 *
 */

    import * as SiteNavigation from './site-navigation.components';

    import GlobalContext from 'proj/contexts/global';
    
    import { useEffect, useState, useContext } from 'react';

    export default ( { value, userEnabled, adSpecId, ...props } ) =>
    {
        const {
            authToken, 
            userLogout,
            socialProvider,
            setUserLoginRequested } = useContext(GlobalContext);

        const [showOptions, setShowOptions] = useState(false);

        const onAccountClicked = e =>
        {
            setShowOptions(!showOptions);
        }

        const onLoginClicked = e => setUserLoginRequested(true);

        const onLogOutClicked = e =>
        {

        }

        const onServiceClick = (e) =>
        {
            if(!socialProvider) return;

            let service = e.currentTarget.dataset['service'],
                data = socialProvider.getDefaultMetaValues();

            if(service == "twitter")
            {
                socialProvider.share(service, 'share', data);
            }
            else
            {
                let newData = {
                    'og:url': data.url,
                    'og:title': data.title,
                };

                if(FB && FB.ui)
                {
                    FB.ui({
                        method: 'share',
                        action_type: 'og.shares',
                        action_properties: JSON.stringify({ object: newData })
                    },
                    (res) => {});
                }
            }
        }

        const onSettingsOptionClicked = e =>
        {
            window.location.href = "https://stage.next.cnn.com/account/settings";
        }

        const onLogOutOptionClicked = e =>
        {
            setShowOptions(false);
            userLogout();
        }

        const getShareBar = () => 
            <SiteNavigation.ShareBar>
                <SiteNavigation.Twitter onClick={ onServiceClick } />
                <SiteNavigation.Facebook onClick={ onServiceClick } />
            </SiteNavigation.ShareBar>

        const getUserToolBar = () => userEnabled &&
            <SiteNavigation.UserToolBar>
                { authToken && getUser() || getLogin() }
                { showOptions && getUserOptions() }
            </SiteNavigation.UserToolBar>

        const getLogin = () =>
            <SiteNavigation.AccountLoggedOut onClick={ onLoginClicked } />

        const getUser = () => authToken &&
            <SiteNavigation.AccountLoggedIn onClick={ onAccountClicked } />

        const getUserOptions = () => showOptions &&
            <SiteNavigation.AccountOptions>
                <SiteNavigation.OptionsList>
                    <SiteNavigation.OptionsItem text={ "Settings" } onClick={ onSettingsOptionClicked } />
                    <SiteNavigation.OptionsItem text={ "Log Out" } onClick={ onLogOutOptionClicked } />
                </SiteNavigation.OptionsList>
            </SiteNavigation.AccountOptions>


        useEffect(() =>
        {

        }, []);

        return  <SiteNavigation.Nav>
                    
                    <SiteNavigation.Bar>

                        <SiteNavigation.Content>
                            
                            <a href={ "https://cnn.com" } rel={ "noopener" }><SiteNavigation.CNNBadge /></a>
                            
                            <SiteNavigation.Spacer />

                            <SiteNavigation.ToolBar>
                                { getShareBar() }
                                { getUserToolBar() }
                            </SiteNavigation.ToolBar>

                        </SiteNavigation.Content>
                    </SiteNavigation.Bar>
                </SiteNavigation.Nav>
    }
